import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { addStudent } from "../services/userService";

export default function Signup() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [authErrorMsg, setAuthErrorMsg] = useState("");

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSignup = async (e) => {
    e.preventDefault();

    // Trim all input values
    const trimmedFullName = fullName.trim();
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();
    const trimmedConfirmPassword = confirmPassword.trim();

    if (trimmedPassword !== trimmedConfirmPassword) {
      handleAuthErrorMsg("Passwords do not match!");
      return;
    }

    const payload = {
      name: trimmedFullName,
      email: trimmedEmail,
      password: trimmedPassword,
    };

    const newUser = await addStudent(payload);
    if (newUser && newUser?.id) {
      navigate("/login");
    } else {
      handleAuthErrorMsg(newUser.message);
    }
  };

  const handleAuthErrorMsg = (errorMsg) => {
    setAuthErrorMsg(errorMsg);
    setTimeout(() => {
      setAuthErrorMsg("");
    }, 3000);
  };

  return (
    <div className="flex h-screen">
      {/* Left Column - Title */}
      <div className="hidden md:flex flex-col justify-center items-center w-1/2 text-white p-8" style={{ background: 'linear-gradient(135deg, #00428a 0%, #55c900 100%)' }}>
        <div className="flex flex-col items-center text-center max-w-md">
          <img
            src="/assets/images/bhit-logo.png"
            alt="BHIT Logo"
            className="h-16 w-auto mb-6"
          />
          <h1 className="text-3xl font-bold mb-4">Join BHIT Training!</h1>
          <p className="text-xl text-gray-200 mb-6">Start Your Learning Journey</p>
          
          <div className="space-y-4 text-left">
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#55c900' }}></div>
              <p className="text-gray-200 mb-0">Get access to industry-standard courses</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#55c900' }}></div>
              <p className="text-gray-200 mb-0">Learn from experienced professionals</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#55c900' }}></div>
              <p className="text-gray-200 mb-0">Build real-world projects and skills</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#55c900' }}></div>
              <p className="text-gray-200 mb-0">Join a community of learners</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#55c900' }}></div>
              <p className="text-gray-200 mb-0">Get career guidance and support</p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column - Signup Form */}
      <div className="flex flex-col justify-center items-center w-full md:w-1/2 bg-gray-50 dark:bg-gray-900 p-6">
        {/* Back to Home Button */}
        <div className="w-full max-w-sm mb-4">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-sm font-medium px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-md"
            style={{ 
              color: '#00428a',
              backgroundColor: 'white',
              border: '1px solid #e5e7eb'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f9fafb';
              e.target.style.borderColor = '#00428a';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.borderColor = '#e5e7eb';
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Back to Home
          </button>
        </div>
        <div className="w-full max-w-sm bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
          {authErrorMsg && (
            <div className="mb-4 text-red-600 text-sm text-center bg-red-100 p-2 rounded">
              {authErrorMsg}
            </div>
          )}
          <div className="flex flex-col items-center mb-6">
            {/* <img
              src="/assets/images/bhit-logo.png"
              alt="BHIT Logo"
              className="h-12 w-auto mb-3 dark:filter dark:brightness-0 dark:invert"
            /> */}
            <h2 className="text-2xl font-bold text-center text-gray-800 dark:text-gray-200">
              Sign Up
            </h2>
          </div>
          <form onSubmit={handleSignup} className="space-y-4">
            {/* Full Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Full Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter your full name"
                required
                value={fullName}
                onChange={(e) => setFullName(e.target.value.trimStart())}
                onBlur={(e) => setFullName(e.target.value.trim())}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-white"
                style={{ borderColor: '#00428a' }}
                onFocus={(e) => e.target.style.borderColor = '#55c900'}
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value.trim())}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-white"
                style={{ borderColor: '#00428a' }}
                onFocus={(e) => e.target.style.borderColor = '#55c900'}
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Password <span className="text-red-500">*</span>
              </label>
              <input
                type="password"
                placeholder="Enter your password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-white"
                style={{ borderColor: '#00428a' }}
                onFocus={(e) => e.target.style.borderColor = '#55c900'}
              />
            </div>

            {/* Confirm Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Confirm Password <span className="text-red-500">*</span>
              </label>
              <input
                type="password"
                placeholder="Re-enter your password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-white"
                style={{ borderColor: '#00428a' }}
                onFocus={(e) => e.target.style.borderColor = '#55c900'}
              />
            </div>

            <button
              type="submit"
              className="w-full text-white py-2 rounded-lg transition"
              style={{ backgroundColor: '#55c900' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#48b000'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#55c900'}
            >
              Create Account
            </button>
          </form>

          <p className="mt-4 text-center text-sm text-gray-600 dark:text-gray-400">
            Already have an account?{" "}
            <a
              onClick={() => navigate("/login")}
              style={{ color: '#00428a' }}
              className="hover:underline cursor-pointer"
            >
              Login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
